function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81v8.37C0 17.83 2.17 20 5.81 20h8.37c3.64 0 5.81-2.17 5.81-5.81V5.81C20 2.17 17.83 0 14.19 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.83 1.55c-1.05 2.61-3.43 6.02-5.71 8.25a4.763 4.763 0 00-4.05-3.96c2.24-2.28 5.67-4.7 8.29-5.76.46-.18.93-.04 1.21.25.31.3.45.76.26 1.22z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M14.12 9.79c-.4.39-.8.75-1.18 1.05l-1.57 1.26c-.2.14-.4.26-.62.36 0-.15-.02-.3-.03-.46-.09-.66-.39-1.29-.93-1.83a3.31 3.31 0 00-1.88-.94c-.16-.02-.33-.02-.48-.02.09-.25.22-.48.39-.67l1.25-1.57c.3-.38.64-.76 1.01-1.14 2.07.29 3.72 1.91 4.04 3.96z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75 12.47c0 .88-.34 1.72-.97 2.35-.49.49-1.14.83-1.94.93l-1.96.22c-1.07.12-1.99-.8-1.87-1.88l.22-1.96c.19-1.75 1.65-2.87 3.2-2.9.15-.01.32 0 .48.02.68.09 1.33.4 1.88.94.53.53.84 1.17.93 1.83.01.15.03.3.03.45z"
})));